'use client';

import { logger } from '@lichtblick/logger';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { startTransition, useEffect } from 'react';

import styles from './error.module.scss';

type ErrorProps = { error: Error & { digest?: string }; reset: () => void };

const ErrorPage: React.FC<ErrorProps> = ({ error, reset }) => {
  useEffect(() => {
    logger.error(`Uncaught Error on page ${window.location.pathname}`, {}, error);
  }, [error]);

  const reload = () => {
    startTransition(() => {
      window.location.reload();
    });
  };

  return (
    <section className={styles.section}>
      <Headline align="center" renderAs="h1">
        Ein unbekannter Fehler ist aufgetreten
      </Headline>
      {/* Next won't be able to recover from a Chunk Load Error – just reload */}
      <BoxCTA as="button" onClick={error.name === 'ChunkLoadError' ? reload : reset}>
        Erneut versuchen
      </BoxCTA>
      <TextCTA as="a" href="/" slim>
        Zurück zur Homepage
      </TextCTA>
    </section>
  );
};

export default ErrorPage;
